import { Box, Text } from '@usap/uicomponents'
import styled from 'styled-components'

const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');
const halfWidth = props => props.theme.global.size.half;
const fullWidth = props => props.theme.global.size.full;
const pageWidth = props => props.theme.global.size.pageWidth;

export const SignUpBox = styled(Box)`
  width: ${pageWidth};
  margin: 0px auto;
  padding: 24px 16px;
  
  ${tabletBreakpoints} {
    padding: ${({isMembershipEnabled}) => isMembershipEnabled ? '40px' : '56px 40px'} ;
  }
`

export const SignInBox = styled(Box)`
  width: ${fullWidth};
  display: ${props => (props.isRegister ? 'none' : 'flex')};

  ${tabletBreakpoints} {
    width: ${halfWidth};
    display: flex;
  }
`

export const FormContainer = styled(Box)`
  flex-direction: column;

  ${tabletBreakpoints} {
    flex-direction: row;
    gap:24px;
  }
`

export const RegisterBox = styled(Box)`
  width: ${fullWidth};
  display: ${props => (props?.isRegister ? 'flex' : 'none')};

  ${tabletBreakpoints} {
    width: ${halfWidth};
    display: flex;
  }
`

export const UserInfoMsgWMOContainer = styled(Box)`
  margin-bottom: 8px;
`
